<!--
<h1>This is the protected dashboard</h1>
<button (click)="onLogout()">Log out</button>
-->
<div fxFlexFill fxLayoutAlign="center center">
  <!-- <mat-spinner *ngIf="showSpinner"></mat-spinner> -->
  <div fxFlexFill id="dashboardContainer"></div>
</div>

